import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Problem } from './components/Problem';
import { Features } from './components/Features';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { Checkout } from './components/Checkout';
import { Footer } from './components/Footer';
import { StickyBar } from './components/StickyBar';
import { CountdownTimer } from './components/CountdownTimer';
import { MetaPixel } from './components/MetaPixel';
import { MetaHead } from './components/MetaHead';
export function App() {
  return <div className="font-sans bg-[#FDF8F3] text-[#333333] min-h-screen" data-id="element-0">
      <MetaHead data-id="element-1" />
      <MetaPixel data-id="element-2" />
      <Header data-id="element-3" />
      <CountdownTimer data-id="element-4" />
      <main data-id="element-5">
        <Hero data-id="element-6" />
        <Problem data-id="element-7" />
        <Features data-id="element-8" />
        <Testimonials data-id="element-9" />
        <Guarantee data-id="element-10" />
        <FAQ data-id="element-11" />
        <Checkout data-id="element-12" />
      </main>
      <Footer data-id="element-13" />
      <StickyBar data-id="element-14" />
    </div>;
}